import { ProductDetailsSectionEligibility } from '../Sections/Eligibility/ProductDetailsSectionEligibility';
import { ProductDetailsSectionBenefits } from '../Sections/ProductDetailsSectionBenefits';
import { ProductDetailsSectionFees } from '../Sections/ProductDetailsSectionFees';
import { ProductDetailsSectionHighlights } from '../Sections/ProductDetailsSectionHighlights';
import { ProductDetailsSectionOffersPl } from '../Sections/ProductDetailsSectionOffersPl/ProductDetailsSectionOffersPl';
import { ProductDetailsStickyFooter } from '../Sections/StickyFooter/ProductDetailsStickyFooter';
import { StickyNavigationBar } from '../Sections/StickyNavigationBar/StickyNavigationBar';
import { visibleSections } from '../utils/sections';
import {
  hasProductOffers,
  isBenefitsSectionVisible,
  isEligibilitySectionVisible,
  isFeesSectionVisible,
  isHighlightsSectionVisible,
} from '../utils/sectionVisibility/sectionVisibility';
import { SectionBuilder } from './types';

/**
 * Personal Loans: the PL Offers section (reward matrix, summary card and details panel, sharing the
 * page calculator's loan selection that the fe PL wrapper injects); the other sections are the
 * default ones for now, with the default sticky nav.
 */
export const buildPersonalLoansSections: SectionBuilder = (
  props,
  staticText,
) => {
  const { product, pushDataLayer } = props;

  return {
    Navigation: StickyNavigationBar,
    Footer: ProductDetailsStickyFooter,
    sections: visibleSections([
      {
        id: 'offers',
        label: staticText.pd_nav_offers,
        visible: hasProductOffers(product),
        render: () => (
          <ProductDetailsSectionOffersPl
            product={product}
            pushDataLayer={pushDataLayer}
            loanSearchParams={props.loanSearchParams}
            onLoanSearchParamsChange={props.onLoanSearchParamsChange}
          />
        ),
      },
      {
        id: 'highlights',
        label: staticText.pd_nav_highlights,
        visible: isHighlightsSectionVisible(product),
        render: () => (
          <ProductDetailsSectionHighlights
            {...product}
            pushDataLayer={pushDataLayer}
          />
        ),
      },
      {
        id: 'benefits',
        label: staticText.pd_nav_benefits,
        visible: isBenefitsSectionVisible(props),
        render: () => <ProductDetailsSectionBenefits {...props} />,
      },
      {
        id: 'fees',
        label: staticText.pd_nav_fees,
        visible: isFeesSectionVisible(product),
        render: () => (
          <ProductDetailsSectionFees
            {...product}
            pushDataLayer={pushDataLayer}
          />
        ),
      },
      {
        id: 'eligibility',
        label: staticText.pd_nav_eligibility,
        visible: isEligibilitySectionVisible(product),
        render: () => (
          <ProductDetailsSectionEligibility
            product={product}
            pushDataLayer={pushDataLayer}
          />
        ),
      },
    ]),
  };
};
